'use strict'
import axios from 'axios'
import { Message } from 'element-ui';
import GLOBAL from '@/utils/global.js'

axios.defaults.headers.post['Content-Type'] = 'application/json'

let config = {
  baseURL: GLOBAL.baseURL,
  timeout: 5000,
  headers: {
    // token: '',
  }
}

// axios内部公用变量和方法
let common = {
  showMessage: function (msg) { // 提示错误信息
    Message({
      message: msg,
      type: "error",
    });
  },
  quitCurrentUser: function () {
    sessionStorage.removeItem("token");
    sessionStorage.removeItem("profile");
    location.replace("/");
  }
}

export const _axios = axios.create(config)

_axios.interceptors.request.use(
  config => {
    // Do something before request is sent
    // config.headers.token = 'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJtb2JpbGUiOiIxMzM2NjY5OTk5OSIsImlhdCI6MTY2Nzc0MzcwOSwiZXhwIjoxNjY3ODMwMTA5fQ.FHBEYWw7vfpsMUqO9HI1oo14_Ja3H4YpQxRupJllmYE';

    if (sessionStorage.getItem('token') && !config.headers.token) {
      config.headers.token = sessionStorage.getItem('token');
    }


    return config
  },
  error => {
    // Do something with request error
    return Promise.reject(error)
  }
)

// Add a response interceptor
_axios.interceptors.response.use(
  response => {
    return response
  },
  error => {
    // if (error && Object.prototype.hasOwnProperty.call(error, "response") && Object.prototype.hasOwnProperty.call(error.response, "status")) {
    //   common.showMessage(error.response.status);
    //   // setTimeout(() => { common.quitCurrentUser() }, 1000);
    // }
    if (error.response.status === 701) {
      common.showMessage('参数不合法');
    }
    if (error.response.status === 801) {
      common.showMessage('用户不存在');
    }
    //如果返回802(无权限)应该跳转（原始地址）
    if (error.response.status === 802) {
      common.showMessage('该账户无权限');
      setTimeout(() => { 
        location.replace("/Data");
        // window.history.go(-1);
        // this.$router.go(-1);
      }, 2000);
    }
    if (error.response.status === 803) {
      common.showMessage('未登录');
      setTimeout(() => { 
        location.replace("/");
        // window.history.go(-1);
        // this.$router.go(-1);
      }, 2000);
    }
    if (error.response.status === 812) {
      common.showMessage('密码错误');
    }



    return Promise.reject(error)
  }
)
